import { css } from 'styled-components';
import { variant } from 'styled-system';
import { FormItemStatus } from '../Form';
import { TextFieldInputVariants } from './TextFieldInput.decl';
export var makeTextFieldInputSize = function makeTextFieldInputSize(_ref) {
  var size = _ref.size,
      theme = _ref.theme;
  return theme.textFieldInput.sizes[size];
};
export var shouldForwardProp = function shouldForwardProp(prop) {
  return !['size', 'error'].includes(prop);
};
export var makeTextFieldVariant = function makeTextFieldVariant(_ref2) {
  var theme = _ref2.theme,
      icon = _ref2.icon;
  return css(["", " width:100%;padding:", ";color:", ";font-size:", ";line-height:20px;font-family:", ";caret-color:", ";appearance:none;box-sizing:border-box;transition:all 300ms;&:disabled{background-color:", ";border-color:", ";color:", ";}&:focus{outline:none;}"], variants, icon ? '0 16px 0 48px' : '0 16px', theme.colors.text.base, theme.typography.variants.body.fontSize, theme.typography.fontFamily, theme.colors.primary.base, theme.colors.grey.light, theme.colors.grey.light, theme.colors.grey.dark);
};
export var makeTextFieldValidationStatus = function makeTextFieldValidationStatus(_ref3) {
  var _validationStatusColo;

  var theme = _ref3.theme,
      validationStatus = _ref3.validationStatus,
      variant = _ref3.variant;

  if (!validationStatus) {
    return;
  }

  var validationStatusColorMap = (_validationStatusColo = {}, _validationStatusColo[FormItemStatus.ERROR] = theme.colors.red.dark, _validationStatusColo[FormItemStatus.SUCCESS] = theme.colors.green.dark, _validationStatusColo);
  var validationStatusColor = validationStatusColorMap[validationStatus];
  return "\n    color: " + validationStatusColor + ";\n    border-color: " + validationStatusColor + ";\n    caret-color: " + validationStatusColor + ";\n\n    &:focus {\n      border-color: " + validationStatusColor + ";\n      " + (variant === TextFieldInputVariants.INPUT && "box-shadow: 0 0 0 1px " + validationStatusColor + ";") + "\n      " + (variant === TextFieldInputVariants.LIST && "box-shadow: 0px 1px 1px -1px " + validationStatusColor + ";") + "\n    }\n  ";
};
var variants = variant({
  variants: {
    input: {
      backgroundColor: 'base.white',
      borderRadius: '8px',
      borderWidth: '1px',
      borderStyle: 'solid',
      borderColor: 'grey.base',
      ':focus': {
        borderColor: 'base.black'
      }
    },
    list: {
      backgroundColor: 'base.white',
      border: 'none',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'grey.base',
      ':focus': {
        borderColor: 'grey.dark'
      }
    }
  }
});